import { Moment } from 'moment';
import { SchedulerEventType } from 'components/organisms/resource-management/event-types';
import { ViewPresetId } from 'components/organisms/resource-management/scheduler-config/view-presets/constants';

export const idForDemandEvent = (
  type: SchedulerEventType,
  roleId: number,
  startDate: Moment,
  viewPreset: ViewPresetId,
): string => `${type}_${viewPreset}_role-${roleId}_${startDate.valueOf()}`;
